<div class="quiz-detail-page">
  <!-- Loading -->
  <div class="loading-container" *ngIf="loading">
    <mat-spinner diameter="36"></mat-spinner>
    <p>Loading quiz...</p>
  </div>

  <!-- Error -->
  <div class="error-state" *ngIf="error">
    <mat-icon>error_outline</mat-icon>
    <p>{{ error }}</p>

    <button mat-stroked-button (click)="loadQuiz(quizId)">
      <mat-icon>refresh</mat-icon>
      Retry
    </button>
  </div>

  <!-- Content -->
  <div class="quiz-content" *ngIf="!loading && !error && quiz">
    <!-- Intro / overview -->
    <section class="quiz-intro" *ngIf="!isTaking && !result">
      <div class="intro-copy">
        <span class="eyebrow"> {{ quiz.questions_count }} QUESTIONS </span>

        <h1>{{ quiz.title }}</h1>

        <p class="quiz-description" *ngIf="quiz.description">
          {{ quiz.description }}
        </p>
      </div>

      <div class="quiz-meta">
        <span *ngIf="quiz.owner?.username">
          <mat-icon>person_outline</mat-icon>
          {{ quiz.owner?.username }}
        </span>

        <span *ngIf="quiz.time_since_creation">
          <mat-icon>schedule</mat-icon>
          {{ quiz.time_since_creation }}
        </span>

        <span *ngIf="quiz.likes !== undefined">
          <mat-icon>favorite_border</mat-icon>
          {{ quiz.likes }}
        </span>

        <span *ngIf="quiz.bookmarks !== undefined">
          <mat-icon>bookmark_border</mat-icon>
          {{ quiz.bookmarks }}
        </span>
      </div>

      <div class="quiz-actions">
        <button class="start-button" mat-flat-button (click)="onStartQuiz()">
          <mat-icon>play_arrow</mat-icon>
          Start quiz
        </button>

        <button class="cancel-button" mat-button (click)="onCancel()">Cancel</button>
      </div>
    </section>

    <!-- Result top section -->
    <section class="quiz-result-intro" *ngIf="result">
      <div>
        <span class="eyebrow">COMPLETED</span>
        <h1>{{ quiz.title }}</h1>
      </div>

      <button class="start-button" mat-flat-button (click)="onStartQuiz()">
        <mat-icon>replay</mat-icon>
        Retake
      </button>
    </section>

    <!-- Quiz -->
    <main class="quiz-body">
      <ddc-quiz-questions
        [isTaking]="isTaking"
        [quiz]="quiz"
        [result]="result"
        (onNextQuestion)="onNextQuestion()"
        (onPreviousQuestion)="onPreviousQuestion()"
        (onSubmitAnswer)="onAnswerSelect($event.questionId, $event.answerId)"
        (onSubmitQuiz)="onSubmitQuiz()"
      >
      </ddc-quiz-questions>
    </main>
  </div>
</div>
